// =============================================================================
// 基于 docs/ui_sidebar/templates/02-nav-schema.ts.template 适配为 gitman
// 注意:此文件含 JSX(图标),必须用 .tsx 扩展名。
// 菜单 = 声明式配置；新增模块无需修改 Layout 本体。
// gitman 无细粒度权限,仅区分 admin / 普通登录用户:
//   · admin 用户 -> permissions=["*"]
//   · 普通登录用户 -> permissions=["user:view"]
//   · 未登录 -> permissions=[]
// 管理菜单项标记 permission:"admin",仅 admin(含 "*")可见。
// =============================================================================

import type { ReactElement } from 'react'
import {
  Home20Regular,
  Globe20Regular,
  AppFolder20Regular,
  People20Regular,
  Archive20Regular,
  Settings20Regular,
} from '@fluentui/react-icons'
import { ROUTES } from '../routes'

/** "*" 表示全部权限(admin 角色)；其余为具体权限 key */
export type PermissionKey = string

export interface NavItem {
  /** 路由 path，必须等于 ROUTES 中的某个常量 */
  path: string
  /** 显示名 */
  label: string
  /** Fluent UI 20px 图标组件 */
  icon: ReactElement
  /** 关联权限；缺省表示仅受登录保护（公开路由） */
  permission?: PermissionKey
  /** 折叠态 tooltip 详细描述（用于搜索 / a11y） */
  description?: string
  /** 可选徽章：返回数字 / 字符串 / null */
  badge?: () => number | string | null
}

export interface NavGroup {
  /** section 排序 key，越小越靠前 */
  order: number
  /** 中文 section 名 */
  section: string
  items: NavItem[]
}

// -----------------------------------------------------------------------------
// 顶部独立项（不在分组内呈现，landing 页）
// -----------------------------------------------------------------------------
export const NAV_TOP: NavItem = {
  path: ROUTES.home,
  label: '系统概览',
  icon: <Home20Regular />,
  description: '系统总览与关键指标',
}

// -----------------------------------------------------------------------------
// 菜单分组（order 越小越靠前；section 文案可按需调整）
// -----------------------------------------------------------------------------
export const NAV: NavGroup[] = [
  {
    order: 1,
    section: '代码仓库',
    items: [
      { path: ROUTES.explore, label: '浏览', icon: <Globe20Regular /> },
      {
        path: ROUTES.dashboard,
        label: '我的仓库',
        icon: <AppFolder20Regular />,
        permission: 'user:view',
        description: '我创建或参与的仓库',
      },
    ],
  },
  {
    order: 2,
    section: '管理',
    items: [
      { path: ROUTES.adminUsers, label: '用户管理', icon: <People20Regular />, permission: 'admin' },
      { path: ROUTES.adminRepos, label: '仓库管理', icon: <AppFolder20Regular />, permission: 'admin' },
      { path: ROUTES.adminBackups, label: '备份管理', icon: <Archive20Regular />, permission: 'admin' },
      { path: ROUTES.adminSettings, label: '系统设置', icon: <Settings20Regular />, permission: 'admin' },
    ],
  },
]